/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Debt_Dup_Receipt_CancelInputs */

const vi_customer_debt_dup_receipt_cancel = /** @type {(inputs: Customer_Debt_Dup_Receipt_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hủy`)
};

/**

* @param {Customer_Debt_Dup_Receipt_CancelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_debt_dup_receipt_cancel = /** @type {((inputs?: Customer_Debt_Dup_Receipt_CancelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Debt_Dup_Receipt_CancelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_debt_dup_receipt_cancel(inputs)
});